import React, {useRef, useEffect, useContext} from "react";
import BasicView from "../../components/BasicView";
import HeadsVies from "../../styles/HeadsVies";
import {SecondView} from "../../styles/HeadView";
import {
   FacilitadoresContainerList,
   Facilitador,
   FacilitadorLink,
   FacilidoresListHead,
   FacilidoresListBody,
} from "./components/FacilitadoresStyles";
import Text from "../../styles/Text";
import DownArrow from "../../components/DownArrow";
import {Content} from "../../styles/GlobalStyles";
import {isMobile} from "../../constants/Helpers";
import {HeadersContext} from "../../context/HeadersContext";
import {LoadComponet} from "../../components/loaders/Loader";
import styled from "styled-components";
import {FacilitatorsContext} from "../../context/FacilitatorsContext";
import Color from "../../assets/Colors";

const scrollToRef = (ref) => window.scrollTo({top: ref.current.offsetTop, behavior: "smooth"});

export default function FacilitadoresView() {
   const {getHeader, facilitatorHeader} = useContext(HeadersContext);
   const {getFacilitators, wineList, barList, isLoading} = useContext(FacilitatorsContext);
   const FacilitadoresListRef = useRef(null);
   const goTo = () => scrollToRef(FacilitadoresListRef);

   useEffect(() => {
      getHeader("Facilitator");
   }, []);

   useEffect(() => {
      if (facilitatorHeader.loading) {
         getFacilitators();
      }
   }, [facilitatorHeader]);

   if (facilitatorHeader.loading) return <LoadComponet isVisible={true} />;

   return (
      <BasicView
         imageBack={`http://domecqapi.trebolbit.com/${
            isMobile ? facilitatorHeader.pathImageWebMobile : facilitatorHeader.pathImageWebDesktop
         }`}
      >
         <HeadsVies
            type="Facilitators"
            title={<span>Nuestros facilitadores</span>}
            description="Nuestros facilitadores son altamente reconocidos en el medio y están listos para compartir su experiencia contigo."
            // description={facilitatorHeader.description}
         />
         <SecondView>
            <DownArrow goTo={goTo} />
            <Content ref={FacilitadoresListRef}>
               <FacilitadoresContainerList>
                  <FacilidoresListHead>
                     <img src={require("../../assets/icons/vino_icon.png")} alt="vino" className="titleIcon" />
                     <Text>Vino</Text>
                  </FacilidoresListHead>
                  {isLoading.wine ? (
                     <LoadComponet isVisible={true} />
                  ) : wineList.length === 0 ? (
                     <NoFacilitator />
                  ) : (
                     <FacilidoresListBody>
                        {wineList.map((item) => {
                           // console.log(item);
                           return (
                              <Facilitador key={item.idFacilitator}>
                                 <FacilitadorLink to={`/facilitador/${item.idFacilitator}`}>
                                    <div className="imgSust">
                                       <img
                                          src={`http://domecqapi.trebolbit.com/${
                                             isMobile ? item.pathImageWebMobile : item.pathImageWebDesktop
                                          }`}
                                          alt={item.facilitatorName + " " + item.facilitatorLastName}
                                       />
                                    </div>
                                    <Text>{item.facilitatorName + " " + item.facilitatorLastName}</Text>
                                 </FacilitadorLink>
                              </Facilitador>
                           );
                        })}
                     </FacilidoresListBody>
                  )}
               </FacilitadoresContainerList>

               <FacilitadoresContainerList>
                  <FacilidoresListHead>
                     <img src={require("../../assets/icons/barra_icon.png")} alt="barra" className="titleIcon" />
                     <Text>Barra</Text>
                  </FacilidoresListHead>
                  {isLoading.bar ? (
                     <LoadComponet isVisible={true} />
                  ) : barList.length === 0 ? (
                     <NoFacilitator />
                  ) : (
                     <FacilidoresListBody>
                        {barList.map((item) => {
                           return (
                              <Facilitador key={item.idFacilitator}>
                                 <FacilitadorLink to={`/facilitador/${item.idFacilitator}`}>
                                    <div className="imgSust">
                                       <img
                                          src={`http://domecqapi.trebolbit.com/${
                                             isMobile ? item.pathImageWebMobile : item.pathImageWebDesktop
                                          }`}
                                          alt={item.facilitatorName + " " + item.facilitatorLastName}
                                       />
                                    </div>
                                    <Text>{item.facilitatorName + " " + item.facilitatorLastName}</Text>
                                 </FacilitadorLink>
                              </Facilitador>
                           );
                        })}
                     </FacilidoresListBody>
                  )}
               </FacilitadoresContainerList>
            </Content>
         </SecondView>
      </BasicView>
   );
}

const NoFacilitator = () => (
   <Cont>
      <p>No hay facilitadores disponibles</p>
   </Cont>
);

const Cont = styled.div`
   width: 100%;
   padding: 2em 0;
   opacity: 0.3;

   p {
      text-align: center;
      font-weight: bold;
      user-select: none;
      color: ${Color.primary};
   }
`;
